import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TinyTotsComponent } from 'src/app/view/tiny-tots/tiny-tots.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    TinyTotsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {path:'',component:TinyTotsComponent}
    ])
  ]
})
export class TinyModule { }
